<script>
import DataProvider from './DataProvider.vue';
import PossibleStatusTransitionRepository from '../../js/repository/PossibleStatusTransitionRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: PossibleStatusTransitionRepository.findForChild,
                params: [this.childId],
                disableLoader: true,
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
